export const loginContainer = 'p-4 pt-7 z-10 h-full';
export const wrapper = 'min-h-full bg-white flex flex-1 flex-col';
